<template>
    <i class="ico-svg-star-outlined">
        <svg v-bind="{ width, height }" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M184.734 1080.542a.855.855 0 01.632.04.787.787 0 01.365.35h0l1.64 3.195 3.66.511a.818.818 0 01.536.305c.119.153.178.35.147.554h0l-2.89 2.925.63 3.525a.722.722 0 01-.133.557.815.815 0 01-.528.318.856.856 0 01-.524-.08h0l-3.27-1.652-3.268 1.652a.854.854 0 01-.63.055.797.797 0 01-.476-.378h0l.55-3.997-2.66-2.493a.737.737 0 01-.237-.529.734.734 0 01.223-.533.83.83 0 01.469-.229h0l3.659-.511 1.64-3.196a.794.794 0 01.465-.389z" transform="translate(-177 -1080)" :stroke="color" />
        </svg>
    </i>
</template>

<script>
export default {
    name: 'IconStarOutlined',

    props: {
        width: {
            type: Number,
            default: 16,
        },

        height: {
            type: Number,
            default: 14,
        },

        color: {
            type: String,
            default: 'currentColor',
        },
    },
};
</script>
